import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { Environment } from '~/types/EnvironmentTypes'
import { buildEnvironment, getApiEnvironment } from '~/utils/common'

import { toNounCasing } from '@mangovoice/core'

import { useEnvironmentLabelStyle } from './componentStyles'

export const EnvironmentLabel = () => {
  const styles = useEnvironmentLabelStyle()

  if (buildEnvironment === Environment.PRODUCTION) {
    return null
  }

  return (
    <Flex css={styles.container}>
      <Text css={styles.text}>
        {toNounCasing(getApiEnvironment())} API Environment
      </Text>
    </Flex>
  )
}
